import React from 'react';

export const InsuranceGapInsurance = () => {
  return (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='white' xmlns='http://www.w3.org/2000/svg'>
      <path d='M21.925 18.457L18.254 5.457C18.011 4.595 17.225 4 16.329 4H14C13.448 4 13 4.448 13 5V8H11V5C11 4.448 10.552 4 9.99997 4H7.67097C6.77497 4 5.98897 4.595 5.74597 5.457L2.07497 18.457C1.71497 19.733 2.67397 21 3.99997 21H9.99997C10.552 21 11 20.552 11 20V16H13V20C13 20.552 13.448 21 14 21H20C21.326 21 22.285 19.733 21.925 18.457ZM11 14V10H13V14H11Z' />
    </svg>
  );
};
